import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
// import * as Sentry from '@sentry/browser';
import { isAuthenticated } from './services/authService';
import { setTokenHeader } from './services/apiService';
import { signout } from './actions/auth';
import reducer from './reducers';
import middleware from './middleware';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import * as storage from './storage';
import './styles/main.css';

// Sentry.init({
//   dsn: 'https://01300357f6ef4c52b558858508ebd6cd@sentry.io/1280096',
//   release: process.env.REACT_APP_SENTRY_RELEASE,
//   environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || 'local',
// });

const token = storage.local.getItem('token');
const authenticated = isAuthenticated();
const store = createStore(
  reducer,
  {
    auth: { authenticated: authenticated ? token : '' },
  },
  middleware,
);
if (token && authenticated) {
  setTokenHeader(token);
} else {
  store.dispatch(signout(() => {}));
}

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root'),
);
registerServiceWorker();
